class Header extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.header = this.querySelector(".header")),
      this.header &&
        ((this.prevScrollPos = window.scrollY),
        (this.hide_offset = 100),
        (this.lastDirection = "up"),
        (this.isScrolling = !1),
        this.scrollListener());
  }
  scrollListener() {
    window.addEventListener(
      "scroll",
      () => {
        this.processScroll();
      },
      { passive: !0 }
    );
  }
  processScroll() {
    const e = window.scrollY,
      s = e > this.prevScrollPos ? "down" : "up";
    e <= this.hide_offset
      ? this.header.setAttribute("aria-hidden", !1)
      : s !== this.lastDirection &&
        ("down" === s
          ? this.header.setAttribute("aria-hidden", !0)
          : this.header.setAttribute("aria-hidden", !1),
        (this.lastDirection = s)),
      (this.prevScrollPos = e);
  }
  disconnectedCallback() {
    window.removeEventListener("scroll", this.scrollListener, { passive: !0 });
  }
}
customElements.define("header-root", Header);
